export const duration = {
  instant: 0,
  fast: 120,
  normal: 200,
  slow: 320,
  slower: 480,
};

export const easing = {
  standard: "cubic-bezier(0.4, 0, 0.2, 1)",
  enter: "cubic-bezier(0, 0, 0.2, 1)",
  exit: "cubic-bezier(0.4, 0, 1, 1)",
  bounce: "cubic-bezier(0.34, 1.56, 0.64, 1)",
};

export const motionPresets = {
  fade: { duration: duration.normal, easing: easing.standard },
  slide: { duration: duration.slow, easing: easing.enter },
  scale: { duration: duration.fast, easing: easing.bounce },
  buttonPress: { duration: duration.fast, easing: easing.standard },
  hoverLift: { duration: duration.normal, easing: easing.standard },
  modal: { duration: duration.slow, easing: easing.enter },
  toast: { duration: duration.normal, easing: easing.enter },
  page: { duration: duration.slower, easing: easing.standard },
  loading: { duration: duration.slower, easing: easing.standard },
  success: { duration: duration.normal, easing: easing.bounce },
  error: { duration: duration.normal, easing: easing.exit },
};
